import React, { useState, useEffect } from "react";
import "./rateCards.css";
import {
  Breadcrumb,
  notification,
  Button,
  Select,
  Table,
  Input,
  Image,
  Modal,
} from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import moment from "moment/moment";
import { GreenNotify, RedNotify } from "../../helper/helper";

import RateCard from "../../components/addRateCard/addRateCard";

import {
  crossIcon,
  homeIcon,
  editIcon,
  redTrash,
  trueIcon,
} from "../../assets";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const UserList = () => {
  const [rateCards, setRateCards] = useState([]);

  const [isloading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddCategoryModalVisible, setIsAddCategoryModalVisible] =
    useState(false);
  const getAllRateCards = () => {
    callApi(
      "GET",
      `${routes.getRateCard}`,
      null,
      setIsLoading,
      (res) => {
        console.log("Rate Card", res);
        setRateCards(res?.data?.rateCard);
      },
      (error) => {}
    );
  };

  useEffect(() => {
    getAllRateCards();
  }, []);
  const handleDelete = (recordId) => {
    callApi(
      "DELETE",
      `${routes.deleteRateCard}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          setRateCards((prevSub) =>
            prevSub.filter((sub) => sub._id !== recordId)
          );

          GreenNotify("Rate Card Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting record");
        }
      },
      (error) => {
        console.log("error", error);

        notification.error({
          message: "Error",
          description: "An error occurred while deleting record.",
        });
      }
    );
  };

  const handleAddClient = () => {
    setUpdateRecordData(null);
    setIsAddCategoryModalVisible(true);
  };

  const makeFree = async (recordId) => {
    console.log("Record ID:", recordId);
    const selectedCategory = rateCards.find(
      (rateCard) => rateCard._id === recordId
    );
    if (selectedCategory) {
      setUpdateRecordData(selectedCategory);
      setIsAddCategoryModalVisible(true);
    } else {
      console.error("Record not found!");
    }
  };

  const columns = [
    {
      title: "Pre fix",
      dataIndex: "prefix",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Rate",
      dataIndex: "rate",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "_id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => makeFree(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
          ></Button>
        </div>
      ),
      width: "auto",
    },
  ];

  const data = rateCards
    ?.map((item, index) => {
      console.log("Item.............", item);
      return {
        key: index,
        _id: item?._id,
        prefix: item?.prefix || "N/A",
        rate: item?.rate || "N/A",
      };
    })
    .filter((item) => {
      if (!searchText) return true;

      const usernameMatch = item?.prefix
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const emailMatch = item?.rate
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());

      return usernameMatch || emailMatch;
    });
  console.log("Data>>>>>>>>>>", data);
  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };

  const handleViewDetails = async (record) => {
    let getRes = (res) => {
      setSelectedUser(res?.user);
      setModalVisible(true);
    };

    const result = await callApi(
      "GET",
      `${routes.getUserData}/${record._id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };
  const handleCloseModal = () => {
    setSelectedUser(null);
    setModalVisible(false);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Rate Cards</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Rate Cards</h1>
        <div></div>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search Prefix or rate"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAddClient}
        style={{ marginBottom: "16px" }}
      >
        Add Rate Card
      </Button>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        ></Table>
      </div>
      <Modal
        title={
          <span
            className={
              modalVisible
                ? "blink-animation user-details-label"
                : "user-details-label"
            }
          >
            User Details 👇
          </span>
        }
        visible={modalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        {selectedUser && (
          <div style={{ padding: "20px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  marginRight: "20px",
                  fontWeight: "bold",
                  fontSize: "30px",
                  animation: "fadeIn 1s ease",
                }}
              >
                {`${selectedUser?.fullName}`}
              </div>
              <div style={{ marginLeft: "150px" }}>
                <Image
                  style={{
                    borderRadius: "50%",
                    width: "140px",
                    height: "140px",
                  }}
                  src={selectedUser?.image}
                  alt="profile-image"
                />
              </div>
            </div>
          </div>
        )}
      </Modal>

      <RateCard
        visible={isAddCategoryModalVisible}
        toggleModal={() => {
          setIsAddCategoryModalVisible(false);
          getAllRateCards();
        }}
        recordData={updateRecordData}
      />
    </div>
  );
};

export default UserList;
